export default {
  actionProdutoForca({commit}, produtoForca){
    commit("setProdutoForca", produtoForca)
  }
}
